export const siteInfo = {
  name: "可游漫画网",
  shortName: "可游漫画",
  slogan: "游戏情报一站掌握",
  description: "汇聚游戏资讯与联动情报，跟进新游漫画化、版本更新漫画及活动漫画内容。",
  email: "contact@keyoumanga.example",
  url: "https://gamereport1.github.io/",
};

export const categories = [
  {
    slug: "youxi-zixun",
    name: "游戏资讯",
    short: "资讯",
    icon: "ri-gamepad-line",
    color: "bg-primary-500",
    desc: "热门游戏一手快讯与业界动态",
    count: 24,
  },
  {
    slug: "liandong-qingbao",
    name: "联动情报",
    short: "联动",
    icon: "ri-hand-heart-line",
    color: "bg-accent-500",
    desc: "游戏×动画、IP跨界合作追踪",
    count: 18,
  },
  {
    slug: "xinyou-manhuahua",
    name: "新游漫画化",
    short: "漫画化",
    icon: "ri-pen-nib-line",
    color: "bg-secondary-500",
    desc: "新游改编漫画抢先看",
    count: 16,
  },
  {
    slug: "banben-gengxin",
    name: "版本更新",
    short: "更新",
    icon: "ri-refresh-line",
    color: "bg-primary-700",
    desc: "版本更新漫画与活动内容速递",
    count: 22,
  },
];